import React from 'react'
import Grid from '@material-ui/core/Grid';
import {SimpleSelect} from '../../utils/engageComponents';

export const SuperUserDropDown = ({
    stateOpen = false,
    localStorageSetItem = undefined,
    localStorageRemoveItem = undefined,
    SetHeaderButtons =undefined,
    handleCommunityCombo = undefined,
    setState = undefined,
    communityData = [],
    superUserCommunitySelected = {},
    openCommunityCombo,
    handleCommunityOnBlur = undefined,
    GetCategories = undefined,
    FilterActivitiesByDate = undefined,
    dispatchActions = undefined
}) =>{

    return (
        <Grid item container onClick={handleCommunityCombo} >
            <SimpleSelect
                idToSet={'SuperUserCombo'}
                label={'Community'}
                onChangeHandler = {
                    (evet, newItem) => 
                    {   
                        if(newItem !== null && newItem !== ''){ 

                            if(localStorageSetItem)
                                localStorageSetItem('communityId',newItem.communityId)
                        
                            let objToSet = undefined;
                            if(FilterActivitiesByDate){
                                objToSet ={
                                    CommunitySelected :newItem,
                                    filterObj:{}
                                }
                            }else{
                                objToSet ={
                                    superUserCommunitySelected :newItem,
                                }
                            }

                            if(setState)
                                setState(objToSet)
                                
                        } else{

                            if(localStorageRemoveItem)
                                localStorageRemoveItem('communityId')
                             
                                let objToSet = undefined;
                                if(FilterActivitiesByDate){
                                    objToSet ={
                                        CommunitySelected :undefined,
                                        filterObj:{}
                                    }
                                }else{
                                    objToSet ={
                                        superUserCommunitySelected :undefined,
                                    }
                                }

                            if(setState)
                                setState(objToSet)

                        
                        }
                        
                        if(SetHeaderButtons)
                            SetHeaderButtons(stateOpen)

                        if(GetCategories)
                            GetCategories()

                        if(FilterActivitiesByDate)
                            FilterActivitiesByDate(0,newItem)
                        if(dispatchActions){
                            dispatchActions()
                        }
                    }
                }
                optionsItemsIconsData = {communityData? communityData : []}
                selected = {superUserCommunitySelected? superUserCommunitySelected :{}}
                disabled= {false}
                open={openCommunityCombo}
                onBlur={handleCommunityOnBlur}
            />
        </Grid>
    );
}

export default SuperUserDropDown